
































import Address from '@/types/Address.interface'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    props: {
        //  The address to display in the block
        address: {
            type: Object as PropType<Address>,
            default: null
        },
        //  The style to apply to our address
        addressStyle: {
            type: String,
            default: null
        },
        //  The headline displayed in the google map info window
        headline: {
            type: String,
            default: null
        },
        //  Indicates if the component is read only (activates the google maps option)
        readonly: {
            type: Boolean,
            default: false
        },
        //  The name of the address
        title: {
            type: String,
            default: ''
        },
        //  Our style to apply to our title
        titleStyle: {
            type: String,
            default: 'height:32px'
        }
    },
    computed: {
        addressLine1(): string {
            //  If the address exists, return line1
            if (this.address.line1) return this.address.line1

            //  Else, return Add Address
            return 'Add Address'
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        addressEdit(): void {
            //  Publish changes to the parent
            this.$emit('edit', this.address)
        },
        //  Pop a PersonMap dialog
        popMap(address: Address): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'person-map',
                width: '100vw',
                props: {
                    address: address,
                    headline: this.headline
                }
            })
        }
    }
})
